import { render, staticRenderFns } from "./form.item.vue?vue&type=template&id=6d9a2786&scoped=true&"
import script from "./form.item.vue?vue&type=script&lang=js&"
export * from "./form.item.vue?vue&type=script&lang=js&"
import style0 from "./form.item.vue?vue&type=style&index=0&id=6d9a2786&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9a2786",
  null
  
)

export default component.exports